module.exports = __webpack_public_path__ + "static/media/huangying.7dccc8ff.png";